import { render, staticRenderFns } from "./LltWithoutTermsOfDeliveryCoverage.vue?vue&type=template&id=5136b5e2&scoped=true&"
import script from "./LltWithoutTermsOfDeliveryCoverage.vue?vue&type=script&lang=js&"
export * from "./LltWithoutTermsOfDeliveryCoverage.vue?vue&type=script&lang=js&"
import style0 from "./LltWithoutTermsOfDeliveryCoverage.vue?vue&type=style&index=0&id=5136b5e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5136b5e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardText,VCol,VContainer,VDataTable,VRow,VTooltip})
